import { useEffect, useRef } from "react";

/**
 * This is a custom hook in JavaScript that sets up an interval for a given callback function with a
 * specified delay.
 * @param callback - The function that will be called repeatedly at the specified interval.
 * @param delay - The delay parameter is the time interval (in milliseconds) between each execution of
 * the callback function. If the delay is set to null, the interval will be cleared and the callback
 * function will not be executed.
 */
const useInterval = (callback, delay) => {
    const savedCallback = useRef();
  
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
}

export default useInterval